<template>
	<isogd-doc-in-point v-bind="doc" v-if="other">
		<template slot="about">
			<div class="qwe"></div>
		</template>
	</isogd-doc-in-point>
</template>
<script>
	import IsogdDocInPoint from "./IsogdDocInPoint";

	export default {
		props: {
			other: {
				type: Object				
			},
		},
		components: {
			IsogdDocInPoint
		},
		computed: {
			doc() {				
				return {
					doc: { name: 'Без документа', geoFeatures: this.other.geoFeatures },
					showAbout:false
				}
			}
		}
	}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.qwe {
		padding-bottom: 1rem;
	}
</style>
